import { render } from "./PaymentForm.vue?vue&type=template&id=3e564dec"
import script from "./PaymentForm.vue?vue&type=script&lang=js"
export * from "./PaymentForm.vue?vue&type=script&lang=js"
script.render = render

export default script